import {
  NOTEHEADS,
  FLAGS,
  RESTS,
  NOTEHEAD_SCALE,
  REST_SCALE,
  FLAG_SCALE,
  FLAG_CONFIG
} from "./glyphDefinitions";

export function drawGlyphSVG({
  layer,
  symbol,
  x,
  y,
  fill = "#000",
  stemUp = true
}) {
  const g = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "g"
  );

  g.setAttribute("transform", `translate(${x}, ${y})`);

  // Dotted values reuse the same base glyph, then add an augmentation dot.
  const isDotted = symbol.startsWith("dotted_");
  const baseSymbol = isDotted ? symbol.replace(/^dotted_/, "") : symbol;

  /* ───────── REST ───────── */
  if (symbol.endsWith("_rest")) {
    const pathData = RESTS[baseSymbol];
    if (!pathData) return;

    const path = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );

    path.setAttribute("d", pathData);
    path.setAttribute("fill", fill);
    path.setAttribute(
      "transform",
      `translate(0,-15) scale(${REST_SCALE},-${REST_SCALE})`
    );

    g.appendChild(path);

    /* DOT */
    if (symbol.indexOf("dotted")!==-1) {
      const dot = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle"
      );

      dot.setAttribute("cx", "14");
      dot.setAttribute("cy", "-20");
      dot.setAttribute("r", "2");

      g.appendChild(dot);
    }
    layer.appendChild(g);
    return;
  }

  /* ───────── NOTEHEAD ───────── */
  const noteheadPath = NOTEHEADS[baseSymbol];
  if (!noteheadPath) return;

  const hasStem = baseSymbol !== "whole_note";

  const notehead = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );

  const isHalf = baseSymbol === "half_note";
  const noteheadScale = isHalf ? 0.033 : NOTEHEAD_SCALE;

  notehead.setAttribute("d", noteheadPath);
  notehead.setAttribute("fill", fill);
  notehead.setAttribute("data-missing-rhythm-notehead", "true");
  if (isHalf) {
    notehead.setAttribute("stroke", fill);
    notehead.setAttribute("stroke-width", "12");
  }
  notehead.setAttribute(
    "transform",
    `scale(${noteheadScale},-${noteheadScale})`
  );

  g.appendChild(notehead);

  /* ───────── STEM ───────── */
  if (hasStem) {
    const stem = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );

    // Keep the palette geometry, but match OSMD's visibly thicker stem.
    // Widen around the same center line so the attachment point does not move.
    const STEM_WIDTH = 1.5;
    const STEM_HEIGHT = 34;
    const STEM_UP_X = 10.45;   // same center as palette x=10.7,width=1
    const STEM_DOWN_X = -0.35; // same center as palette x=-0.1,width=1
    const STEM_UP_Y = -35.5;
    const STEM_DOWN_Y = 1.5;

    stem.setAttribute("x", String(stemUp ? STEM_UP_X : STEM_DOWN_X));
    stem.setAttribute("y", String(stemUp ? STEM_UP_Y : STEM_DOWN_Y));
    stem.setAttribute("width", String(STEM_WIDTH));
    stem.setAttribute("height", String(STEM_HEIGHT));
    stem.setAttribute("fill", fill);

    g.appendChild(stem);
  }

  /* ───────── FLAG ───────── */
  const flagPath = FLAGS[baseSymbol];
  const cfg = FLAG_CONFIG[baseSymbol];

  if (flagPath && cfg && stemUp) {
    const flag = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );

    flag.setAttribute("d", flagPath);
    flag.setAttribute("fill", fill);
    flag.setAttribute(
      "transform",
      `${cfg.translate} ${cfg.scale(stemUp, FLAG_SCALE)}`
    );

    g.appendChild(flag);
  }

  /* DOT */
  if (symbol.indexOf("dotted")!==-1) {
    const dot = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "circle"
    );

    dot.setAttribute("cx", "18");
    dot.setAttribute("cy", "-2");
    dot.setAttribute("r", "1.8");

    g.appendChild(dot);
  }

  layer.appendChild(g);
}
